import { Navigate } from 'react-router-dom';
import AutoformContainer from 'components/autoform/AutoformContainer';
import HydroTreeTab from 'components/hydro-project/HydroTreeTab';
import WrapperEmptyState from 'components/layout/WrapperEmptyState';
import PageWrapper from 'components/utils/PageWrapper';
import AutoformPage from 'pages/AutoformPage';
import HydroProject from 'pages/HydroProject';
import autoformPlaceholder from '../images/autoform-unselected.png';
import hydroPlaceholder from '../images/hydro-unselected.png';
import { FormattedMessage } from 'react-intl';
import { HYDRO_PROJECT_ROUTES } from 'constants/routes';

export const hydroProjectRoutes = {
    path: '/hydro-project',
    element: (
        <PageWrapper titleId="hydro_project">
            <HydroProject />
        </PageWrapper>
    ),
    children: [
        {
            index: true,
            element: <Navigate to={`${HYDRO_PROJECT_ROUTES.PLANT_CONFIG}/${window.location.search}`} />,
        },
        {
            path: HYDRO_PROJECT_ROUTES.PLANT_CONFIG,
            element: (
                <AutoformPage
                    config={{
                        autoformId: HYDRO_PROJECT_ROUTES.PLANT_CONFIG,
                    }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
        {
            path: HYDRO_PROJECT_ROUTES.PLANT_DATA,
            element: (
                <AutoformPage
                    config={{
                        autoformId: HYDRO_PROJECT_ROUTES.PLANT_DATA,
                    }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
        {
            path: HYDRO_PROJECT_ROUTES.PROJECT_CONSTRAINTS,
            element: (
                <AutoformPage
                    config={{
                        autoformId: HYDRO_PROJECT_ROUTES.PROJECT_CONSTRAINTS,
                    }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
        {
            path: HYDRO_PROJECT_ROUTES.ELEVATION_CAPACITY,
            element: (
                <AutoformPage
                    config={{
                        autoformId: HYDRO_PROJECT_ROUTES.ELEVATION_CAPACITY,
                    }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
        {
            path: HYDRO_PROJECT_ROUTES.UNIT_RATINGS_AND_DATA,
            element: (
                <HydroTreeTab
                    autoformId={HYDRO_PROJECT_ROUTES.UNIT_RATINGS_AND_DATA}
                    pageTitle={<FormattedMessage id="hydro_project" />}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState
                            imgSrc={hydroPlaceholder}
                            messages={{
                                header: <FormattedMessage id="no_power_plant_selected" />,
                                body: <FormattedMessage id="select_power_plant_hint" />,
                            }}
                        />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer supressItemRetrievalError={true} />,
                },
            ],
        },
        {
            path: HYDRO_PROJECT_ROUTES.UNIT_OUTAGES,
            element: (
                <AutoformPage
                    config={{
                        autoformId: HYDRO_PROJECT_ROUTES.UNIT_OUTAGES,
                    }}
                    hasSecondaryMenu={true}
                />
            ),
            children: [
                {
                    index: true,
                    element: (
                        <WrapperEmptyState imgSrc={autoformPlaceholder} item="record" page="left" noun="properties" />
                    ),
                },
                {
                    path: ':itemId',
                    element: <AutoformContainer />,
                },
            ],
        },
    ],
};
